<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

defineProps({
  label: { type: String, required: true },
})

const visible = ref(false)

function updateVisibility() {
  visible.value = window.scrollY > Math.max(360, window.innerHeight * 0.45)
}

function scrollToTop() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
}

onMounted(() => {
  updateVisibility()
  window.addEventListener('scroll', updateVisibility, { passive: true })
  window.addEventListener('resize', updateVisibility, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateVisibility)
  window.removeEventListener('resize', updateVisibility)
})
</script>

<template>
  <Transition name="scroll-top">
    <button v-if="visible" class="scroll-to-top" type="button" :aria-label="label" :title="label" @click="scrollToTop">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="m6.5 14.5 5.5-5.5 5.5 5.5" />
      </svg>
      <span>{{ label }}</span>
    </button>
  </Transition>
</template>
